"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SelectMulti = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));
var _styles = require("@material-ui/core/styles");
var _lodash = require("lodash");
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _ArrowDropUp = _interopRequireDefault(require("@material-ui/icons/ArrowDropUp"));
var _SearchInput = _interopRequireWildcard(require("./components/SearchInput"));
var _MenuContainer = _interopRequireDefault(require("./components/MenuContainer"));
var _Popper = _interopRequireDefault(require("../Popper"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _sortUtils = require("../../utils/sort-utils");
var _excluded = ["InputProps"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// outerMenu object that gets props does not get defaultProps
var defaultMenuWidth = '100%';
var inputHeight = 36;
var inputWithHelperTextHeight = 55;
var styles = function styles(theme) {
  return {
    disabledText: {
      color: theme.palette.opacity.black[38]
    },
    errorText: {
      color: theme.palette.accent.redMain
    },
    menuAnchor: {
      height: inputHeight,
      position: 'relative'
    },
    menuAnchorWithHelperText: {
      height: inputWithHelperTextHeight,
      position: 'relative'
    },
    outerMenu: function outerMenu(props) {
      var _props$menuWidth = props.menuWidth,
        menuWidth = _props$menuWidth === void 0 ? defaultMenuWidth : _props$menuWidth;
      return {
        position: 'absolute',
        top: inputHeight,
        width: menuWidth,
        zIndex: 1
      };
    }
  };
};
var defaultProps = {
  actionFooterProps: [],
  asyncDebounceTime: 500,
  automationid: 'fuse-select-multi',
  charsBeforeFetch: 0,
  classes: {},
  dataMetrics: {
    helperText: 'fuse_helper_text',
    input: 'fuse_input',
    label: 'fuse_label',
    loadingMessage: 'fuse_loading_message',
    menuContainer: 'fuse_menu_container',
    noResultsOption: 'fuse_no_results_option',
    optionList: 'fuse_option_list',
    optionListHeader: 'fuse_option_list_header',
    outerMenu: 'fuse_outer_menu',
    root: 'fuse_select_multi',
    searchInput: 'fuse_search_input',
    searchInputWrapper: 'fuse_search_input_wrapper',
    selectAll: 'fuse_select_all',
    selectWrapper: 'fuse_select_wrapper',
    viewSelected: 'fuse_view_selected'
  },
  error: false,
  helperText: null,
  helperTextProps: {},
  inputProps: {},
  isAsync: false,
  isDisabled: false,
  isSorted: true,
  labelProps: {},
  loadingMessage: 'Loading',
  maxDropdownHeight: 260,
  menuWidth: defaultMenuWidth,
  noResultsText: 'No results.',
  options: [],
  placeholder: '',
  portalMenu: true,
  searchPlaceholder: 'Type in to search',
  selectSwitchLabelText: 'View Selected',
  showCountOfSelectedOptions: true,
  showDropdownIndicator: true,
  showOptionListHeader: 'all',
  theme: {},
  variant: 'withMenu'
};

/**
 * Select is a type of input that is used in forms, where a user is submitting data and chooses one or more options from a list.
 * Use a multi-select to give people the ability to search and make one or more choices from multiple options.
 */
var _ref2 = /*#__PURE__*/_react["default"].createElement(_ArrowDropUp["default"], null);
var _ref3 = /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], null);
var SelectMulti = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectMulti, _React$Component);
  var _super = _createSuper(SelectMulti);
  function SelectMulti(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, SelectMulti);
    _this = _super.call(this, props);
    _this.buildGroupOptionsMap = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var results = {};
      options.forEach(function (cur) {
        results[cur.value] = cur;
        if (cur.options) {
          cur.options.forEach(function (subOpt) {
            results[subOpt.value] = _objectSpread({}, subOpt, {
              group: cur.value
            });
          });
        }
      });
      return results;
    };
    _this.openMenu = function () {
      _this.setState({
        menuIsOpen: true
      });
    };
    _this.closeMenu = function () {
      _this.setState({
        menuIsOpen: false
      });
    };
    _this.fetchOptions = function (inputValue) {
      var _this$props = _this.props,
        loadOptions = _this$props.loadOptions,
        value = _this$props.value,
        charsBeforeFetch = _this$props.charsBeforeFetch;
      _this.setState({
        isLoading: true
      });
      var result;
      if (inputValue.length >= charsBeforeFetch) {
        result = loadOptions(inputValue).then(function (data) {
          var unique = (0, _lodash.uniqBy)([].concat((0, _toConsumableArray2["default"])(value), (0, _toConsumableArray2["default"])(data)), 'value');
          _this.setState({
            fetchedOptions: unique,
            isLoading: false
          });
        });
      } else {
        result = Promise.resolve().then(function () {
          _this.setState({
            fetchedOptions: (0, _toConsumableArray2["default"])(value),
            isLoading: false
          });
        });
      }
      return result;
    };
    _this.onWrapperFocus = function () {
      var menuIsOpen = _this.state.menuIsOpen;
      if (!menuIsOpen) {
        _this.openMenu();
      }
    };
    _this.onSearchInputChange = function (event) {
      event.preventDefault();
      var _this$props2 = _this.props,
        isAsync = _this$props2.isAsync,
        charsBeforeFetch = _this$props2.charsBeforeFetch;
      var inputValue = event.target.value;
      _this.setState({
        searchInputValue: inputValue,
        viewSelectedEnabled: false
      });
      if (isAsync) {
        _this.setState({
          isLoading: inputValue.length >= charsBeforeFetch
        });
        _this.optionFetcher(inputValue);
      }
    };
    _this.handleChangeFocus = function () {
      var _this$searchInputRef, _this$searchInputRef$;
      (_this$searchInputRef = _this.searchInputRef) === null || _this$searchInputRef === void 0 ? void 0 : (_this$searchInputRef$ = _this$searchInputRef.current) === null || _this$searchInputRef$ === void 0 ? void 0 : _this$searchInputRef$.focus();
    };
    _this.filterOptions = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$state = _this.state,
        searchInputValue = _this$state.searchInputValue,
        viewSelectedEnabled = _this$state.viewSelectedEnabled;
      var _this$props3 = _this.props,
        value = _this$props3.value,
        charsBeforeFetch = _this$props3.charsBeforeFetch,
        isSorted = _this$props3.isSorted;
      var selectedValues = value ? value.map(function (row) {
        return row.value;
      }) : [];
      var filtered = (0, _toConsumableArray2["default"])(options);

      // Filter to only selected if applicable
      if (viewSelectedEnabled) {
        filtered = filtered.filter(function (row) {
          return selectedValues.indexOf(row.value) > -1;
        });
      }

      // Show rows that match searchInputValue
      filtered = filtered.filter(function (row) {
        // If viewSelectedEnabled, we don't want to filter
        var match = viewSelectedEnabled;
        if (searchInputValue.length >= charsBeforeFetch) {
          match = !_this.isGroup(row) && row.label.toLowerCase().indexOf(searchInputValue.toLowerCase()) > -1;
        }
        return match;
      });
      if (isSorted) {
        if (searchInputValue) {
          filtered.sort(function (a, b) {
            return (0, _sortUtils.sortOptionsForSearch)(a, b, searchInputValue);
          });
        } else {
          filtered.sort(_sortUtils.alphaSortOptions);
        }
      }
      if (_this.hasGroups(filtered)) {
        // Regroup options after sorting
        return _this.adjustOrderForDisplay(filtered, value);
      }
      return filtered;
    };
    _this.adjustOrderForDisplay = function (filtered) {
      var groups = {};
      filtered.forEach(function (opt) {
        if (opt.parentGroup) {
          if (!groups[opt.parentGroup]) {
            var group = _this.optionsMap[opt.parentGroup];
            groups[opt.parentGroup] = [group];
          }
          groups[opt.parentGroup].push(opt);
        } else {
          groups[opt.value] = [opt];
        }
      });
      return Object.values(groups).reduce(function (acc, optGroup) {
        return [].concat((0, _toConsumableArray2["default"])(acc), (0, _toConsumableArray2["default"])(optGroup));
      }, []);
    };
    _this.buildInputDisplay = function (value) {
      var _this$props4 = _this.props,
        placeholder = _this$props4.placeholder,
        showCountOfSelectedOptions = _this$props4.showCountOfSelectedOptions;
      var output;
      if (value && value.length > 0) {
        var valueDisplays = value.map(function (_ref) {
          var label = _ref.label;
          return label;
        });
        if (showCountOfSelectedOptions) {
          output = "(".concat(valueDisplays.length, ") ").concat(valueDisplays.join(', '));
        } else {
          output = valueDisplays.join(', ');
        }
      }
      return output || placeholder;
    };
    _this.onWithMenuClickaway = function () {
      var onInputBlur = _this.props.onInputBlur;
      _this.closeWithMenu();
      if (onInputBlur) {
        onInputBlur();
      }
    };
    _this.onStandaloneClickaway = function () {
      var onInputBlur = _this.props.onInputBlur;
      _this.closeMenu();
      if (onInputBlur) {
        onInputBlur();
      }
    };
    _this.onMenuClick = function () {
      var withMenuIsOpen = _this.state.withMenuIsOpen;
      return withMenuIsOpen ? _this.closeWithMenu() : _this.openWithMenu();
    };
    _this.openWithMenu = function () {
      var _this$props5 = _this.props,
        isDisabled = _this$props5.isDisabled,
        variant = _this$props5.variant;
      if (!isDisabled && variant === 'withMenu') {
        _this.setState({
          withMenuIsOpen: true
        });
      }
    };
    _this.closeWithMenu = function () {
      var variant = _this.props.variant;
      if (variant === 'withMenu') {
        _this.setState({
          withMenuIsOpen: false
        });
      }
      _this.clearInput();
    };
    _this.handleChange = function (newVal) {
      var onChange = _this.props.onChange;
      onChange(newVal);
    };
    _this.onOptionChange = function (event, changedTo) {
      var _this$searchInputRef2, _this$searchInputRef3;
      var value = _this.props.value;
      var options = _this.getOptions();
      var optionValue = event.target.value;
      var availableValues = options.map(function (valueObj) {
        return valueObj.value;
      });
      var isAvailable = availableValues.indexOf(optionValue);
      if (isAvailable === -1) {
        return;
      }
      var selectedOptions = (0, _toConsumableArray2["default"])(value);
      if (changedTo === true) {
        // Selected addtl option
        var valueMap = [];
        var labelMap = [];
        options.forEach(function (optionObj) {
          valueMap.push(optionObj.value);
          labelMap.push(optionObj.label);
        });
        selectedOptions.push({
          label: labelMap[valueMap.indexOf(optionValue)],
          value: optionValue
        });
      } else {
        // De-selected an option
        var _valueMap = value.map(function (valueObj) {
          return valueObj.value;
        });
        var matchingIndex = _valueMap.indexOf(optionValue);
        if (matchingIndex === -1) {
          return;
        }
        selectedOptions.splice(matchingIndex, 1);
        if (selectedOptions.length === 0) {
          _this.setState({
            viewSelectedEnabled: false
          });
        }
      }
      var removedDuplicateOptions = (0, _lodash.uniqBy)((0, _toConsumableArray2["default"])(selectedOptions), 'value');
      _this.handleChange(removedDuplicateOptions);
      (_this$searchInputRef2 = _this.searchInputRef) === null || _this$searchInputRef2 === void 0 ? void 0 : (_this$searchInputRef3 = _this$searchInputRef2.current) === null || _this$searchInputRef3 === void 0 ? void 0 : _this$searchInputRef3.focus();
    };
    _this.hasGroups = function (options) {
      return options.some(function (opt) {
        return opt.parentGroup;
      });
    };
    _this.isGroup = function (option) {
      return option && option.options && option.options.length > 0;
    };
    _this.isChildOption = function (option) {
      return option && option.parentGroup !== undefined;
    };
    _this.handleSelectAll = function (isSelected, optionsWhenToggled) {
      var value = _this.props.value;
      if (isSelected === true) {
        // Take out group option
        var optionsWithValues = optionsWhenToggled.filter(function (row) {
          return !_this.isGroup(row) && !row.isDisabled;
        });
        // combine already selected options, with options when toggled, dedupe
        var combined = (0, _lodash.uniqBy)([].concat((0, _toConsumableArray2["default"])(value), (0, _toConsumableArray2["default"])(optionsWithValues)), 'value');
        _this.handleChange(combined);
      } else {
        /**
         * When selectall is toggled off, remove visible
         * selected values at time of toggle from greater list of values
         */
        var newSelection = (0, _lodash.pullAllWith)(value, optionsWhenToggled, function (v1, v2) {
          return v1.value === v2.value;
        });
        _this.handleChange(newSelection);

        // also remove view selected when deselecting all from a view-selected state
        _this.setState({
          viewSelectedEnabled: false
        });
      }
    };
    _this.handleSelectGroup = function (event, changedTo) {
      var value = _this.props.value;
      var optionValue = event.target.value;
      var options = _this.getFilteredOptions();
      var selectedOptions = (0, _toConsumableArray2["default"])(value);
      var selectedGroup = options.find(function (opt) {
        return opt.value === optionValue;
      });
      if (!selectedGroup) {
        return;
      }
      selectedGroup.indeterminate = false;
      if (selectedGroup.options) {
        if (changedTo) {
          // get items that are not disabled
          var enabledOptions = selectedGroup.options.filter(function (opt) {
            return !opt.isDisabled;
          });
          // select all options in that group
          selectedOptions = (0, _lodash.uniqBy)([].concat((0, _toConsumableArray2["default"])(selectedOptions), (0, _toConsumableArray2["default"])(enabledOptions)), 'value');
        } else {
          selectedOptions = (0, _lodash.pullAllWith)(selectedOptions, selectedGroup.options, function (v1, v2) {
            return v1.value === v2.value;
          });
        }
      }
      if (selectedOptions.length === 0) {
        _this.setState({
          viewSelectedEnabled: false
        });
      }
      _this.handleChange(selectedOptions);
      _this.searchInputRef.current.focus();
    };
    _this.handleViewSelected = function (newValue) {
      _this.setState({
        searchInputValue: '',
        viewSelectedEnabled: newValue
      });
      _this.searchInputRef.current.focus();
    };
    _this.getOptions = function () {
      var _this$props6 = _this.props,
        isAsync = _this$props6.isAsync,
        options = _this$props6.options,
        value = _this$props6.value;
      var fetchedOptions = _this.state.fetchedOptions;

      // reconcile selected values with fetched values
      // alternative to willReceiveProps check to see if value was
      // updated outside of this component after component mount
      var reconciled = (0, _lodash.uniqBy)([].concat((0, _toConsumableArray2["default"])(value), (0, _toConsumableArray2["default"])(fetchedOptions)), 'value');
      var optionsToShow = isAsync ? reconciled : _this.flattenNestedOptions(options);
      return optionsToShow;
    };
    _this.getFilteredOptions = function () {
      var opts = _this.getOptions();
      var filtered = _this.filterOptions(opts);
      return filtered;
    };
    _this.clearInput = function () {
      _this.setState({
        searchInputValue: ''
      });
    };
    _this.handleClearInput = function () {
      _this.clearInput();
      _this.searchInputRef.current.focus();
    };
    _this.flattenNestedOptions = function (options) {
      var flattenedOptions = options.reduce(function (acc, curOpt) {
        if (curOpt.options) {
          var optionsWithGroup = curOpt.options.map(function (opt) {
            return _objectSpread({}, opt, {
              parentGroup: curOpt.value
            });
          });
          acc.push(_objectSpread({}, curOpt, {
            options: optionsWithGroup
          }));
          return acc.concat(optionsWithGroup);
        }
        acc.push(curOpt);
        return acc;
      }, []);
      return flattenedOptions;
    };
    _this.calculateMenuWidth = function () {
      var calculateMenuWidthWorker = function calculateMenuWidthWorker() {
        var menuWidth = _this.props.menuWidth;
        var isNumber = function isNumber(number) {
          return !number.toString().match(/[^0-9]/g);
        };
        if (typeof menuWidth === 'number') {
          return menuWidth;
        }
        var menuWidthStr = menuWidth.toString();
        if (isNumber(menuWidthStr)) {
          return parseInt(menuWidthStr, 10);
        }
        var current = _this.popperAnchorRef.current;
        var clientWidth = current ? current.clientWidth : defaultMenuWidth;
        var index = menuWidthStr.indexOf('%');
        if (index > 0) {
          // if menu width is specified in %%
          return clientWidth * parseInt(menuWidthStr.slice(0, index), 10) / 100;
        }
        index = menuWidthStr.toLowerCase().indexOf('px');
        if (index > 0) {
          // if menu width is specified in pixels
          return parseInt(menuWidthStr.slice(0, index), 10);
        }
        // anything else is not expected, return the anchor's width
        return clientWidth;
      };
      var calculatedWidth = calculateMenuWidthWorker();
      // adjust calculated width to account for input padding, etc.
      if (calculatedWidth - _SearchInput.minWidth <= 5) {
        calculatedWidth = _SearchInput.minWidth + 5;
      }
      return calculatedWidth;
    };
    _this.inputRef = props.inputRef || /*#__PURE__*/_react["default"].createRef(); // Input for withMenu variant
    _this.popperAnchorRef = /*#__PURE__*/_react["default"].createRef(); // drop menu ref for withMenu variant
    _this.wrapperRef = props.wrapperRef || /*#__PURE__*/_react["default"].createRef(); // Wrapper for the standaloneVariant (also used within withMenu variant)
    _this.searchInputRef = props.searchInputRef || /*#__PURE__*/_react["default"].createRef(); // Ref for the typeahead
    _this.menuContainerRef = props.menuContainerRef || /*#__PURE__*/_react["default"].createRef();
    _this.optionFetcher = (0, _lodash.debounce)(_this.fetchOptions, props.asyncDebounceTime);
    _this.optionsMap = _this.buildGroupOptionsMap(props.options);
    _this.state = {
      fetchedOptions: (0, _toConsumableArray2["default"])(props.value),
      isLoading: false,
      menuIsOpen: props.variant === 'withMenu',
      // Interior menu of the standaloneVariant
      searchInputValue: '',
      viewSelectedEnabled: false,
      withMenuIsOpen: false // Outer menu of the withMenu variant
    };
    return _this;
  }

  /**
   * Build a option map for quicker lookup.
   * @param {Array} options
   */
  (0, _createClass2["default"])(SelectMulti, [{
    key: "checkGroupSelectionStatus",
    value: function checkGroupSelectionStatus(options, selectedOptions, group) {
      var availableOptsFromGroup = options.reduce(function (acc, opt) {
        return opt.parentGroup === group.value && !opt.isDisabled ? [].concat((0, _toConsumableArray2["default"])(acc), [opt.value]) : acc;
      }, []);
      var selectedOptsFromGroup = selectedOptions.filter(function (opt) {
        return availableOptsFromGroup.indexOf(opt.value) !== -1;
      });
      return _objectSpread({}, group, {
        indeterminate: selectedOptsFromGroup.length > 0 && availableOptsFromGroup.length > selectedOptsFromGroup.length,
        isAllSelected: availableOptsFromGroup.length && selectedOptsFromGroup.length === availableOptsFromGroup.length
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _theme$zIndex,
        _cx;
      var _this$props7 = this.props,
        actionFooterProps = _this$props7.actionFooterProps,
        actionProps = _this$props7.actionProps,
        automationid = _this$props7.automationid,
        charsBeforeFetch = _this$props7.charsBeforeFetch,
        classes = _this$props7.classes,
        dataMetrics = _this$props7.dataMetrics,
        error = _this$props7.error,
        helperText = _this$props7.helperText,
        helperTextProps = _this$props7.helperTextProps,
        inputProps = _this$props7.inputProps,
        isAsync = _this$props7.isAsync,
        isDisabled = _this$props7.isDisabled,
        label = _this$props7.label,
        labelProps = _this$props7.labelProps,
        loadingMessage = _this$props7.loadingMessage,
        maxDropdownHeight = _this$props7.maxDropdownHeight,
        noResultsText = _this$props7.noResultsText,
        PopperProps = _this$props7.PopperProps,
        portalMenu = _this$props7.portalMenu,
        searchInputProps = _this$props7.searchInputProps,
        searchPlaceholder = _this$props7.searchPlaceholder,
        selectSwitchLabelText = _this$props7.selectSwitchLabelText,
        showDropdownIndicator = _this$props7.showDropdownIndicator,
        showOptionListHeader = _this$props7.showOptionListHeader,
        theme = _this$props7.theme,
        value = _this$props7.value,
        variant = _this$props7.variant;
      var _this$state2 = this.state,
        menuIsOpen = _this$state2.menuIsOpen,
        withMenuIsOpen = _this$state2.withMenuIsOpen,
        searchInputValue = _this$state2.searchInputValue,
        isLoading = _this$state2.isLoading,
        viewSelectedEnabled = _this$state2.viewSelectedEnabled;
      var allSearchInputProps = _objectSpread({}, searchInputProps, {
        handleClearInput: this.handleClearInput,
        onBlur: this.onSearchInputBlur,
        onChange: this.onSearchInputChange,
        placeholder: searchPlaceholder,
        value: searchInputValue
      });
      var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
      var menuContainerProps = {
        handleChangeFocus: this.handleChangeFocus,
        loadingMessageProps: {
          loadingMessage: loadingMessage
        },
        noResultsOptionProps: {
          text: noResultsText
        },
        onClose: this.closeMenu,
        optionsListHeaderProps: {
          handleSelectAll: this.handleSelectAll,
          handleViewSelected: this.handleViewSelected,
          isGroup: this.isGroup,
          selectSwitchLabelText: selectSwitchLabelText,
          showOptionListHeader: showOptionListHeader
        },
        optionsListProps: {
          checkGroupSelectionStatus: this.checkGroupSelectionStatus,
          handleSelectGroup: this.handleSelectGroup,
          isChildOption: this.isChildOption,
          isGroup: this.isGroup,
          maxDropdownHeight: maxDropdownHeight,
          onOptionChange: this.onOptionChange
        }
      };
      var inputDisplayValue = this.buildInputDisplay(value);
      var withMenu = variant === 'withMenu';
      var commonProps = {
        actionFooterProps: actionFooterProps,
        automationid: automationid,
        charsBeforeFetch: charsBeforeFetch,
        dataMetrics: dataMetrics,
        error: error,
        isAsync: isAsync,
        isDisabled: isDisabled,
        isLoading: isLoading,
        menuIsOpen: menuIsOpen,
        options: this.getFilteredOptions(),
        searchInputValue: searchInputValue,
        value: value,
        variant: variant,
        viewSelectedEnabled: viewSelectedEnabled
      };
      var handleKey = function handleKey(event) {
        switch (event.code) {
          case 'Escape':
            _this2.closeWithMenu();
            break;
          case 'Enter':
          case 'Space':
          case 'ArrowDown':
            if (!withMenuIsOpen) {
              _this2.onMenuClick();
            }
            break;
          default:
            break;
        }
      };
      var DropdownIndicator = withMenuIsOpen ? _ref2 : _ref3;
      var ActualSelect = /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
        mouseEvent: menuIsOpen && variant === 'standalone' ? 'onClick' : false,
        onClickAway: this.onStandaloneClickaway
      }, /*#__PURE__*/_react["default"].createElement("div", {
        automationid: "".concat(automationid, "-select-wrapper"),
        "data-metrics": mergedDataMetrics.selectWrapper,
        ref: this.wrapperRef,
        onFocus: this.onWrapperFocus,
        onBlur: this.onWrapperBlur
      }, /*#__PURE__*/_react["default"].createElement(_SearchInput["default"], {
        ref: this.searchInputRef,
        componentProps: allSearchInputProps,
        commonProps: commonProps
      }), /*#__PURE__*/_react["default"].createElement(_MenuContainer["default"], {
        ref: this.menuContainerRef,
        componentProps: menuContainerProps,
        commonProps: commonProps
      })));
      var actualWidth = this.calculateMenuWidth();
      var menuPopperStyle = {
        border: '1px solid rgba(0, 0, 0, 0.24)',
        borderRadius: 0,
        boxShadow: 'none',
        fontSize: 'inherit',
        marginTop: -7,
        padding: 0,
        width: actualWidth,
        zIndex: (_theme$zIndex = theme.zIndex) === null || _theme$zIndex === void 0 ? void 0 : _theme$zIndex.modal
      };
      var Menu;
      if (portalMenu) {
        if (this.popperAnchorRef.current) {
          Menu = /*#__PURE__*/_react["default"].createElement(_Popper["default"], (0, _extends2["default"])({
            anchorEl: this.popperAnchorRef.current,
            modifiers: {
              preventOverflow: {
                enabled: false
              }
            },
            noPadding: true,
            onRequestClose: function onRequestClose() {
              return false;
            },
            open: true,
            onKeyDown: handleKey,
            placement: "bottom-start",
            showArrow: false,
            style: menuPopperStyle
          }, PopperProps), ActualSelect, actionProps && actionProps(this.closeWithMenu));
        }
      } else {
        Menu = /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
          onKeyDown: handleKey,
          square: true,
          className: classes.outerMenu,
          automationid: "".concat(automationid, "-outermenu"),
          "data-metrics": mergedDataMetrics.outerMenu
        }, ActualSelect, actionProps && actionProps(this.closeWithMenu));
      }
      var InputProps = inputProps.InputProps,
        inputPropsRest = (0, _objectWithoutProperties2["default"])(inputProps, _excluded);
      var WithMenu = /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
        onClickAway: this.onWithMenuClickaway
      }, /*#__PURE__*/_react["default"].createElement("div", null, label && /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
        automationid: "".concat(automationid, "-label"),
        dataMetrics: {
          root: mergedDataMetrics.label
        },
        variant: "overline",
        color: withMenuIsOpen ? 'primary' : 'textSecondary',
        classes: {
          root: (0, _classnames["default"])(classes.label, (_cx = {}, (0, _defineProperty2["default"])(_cx, classes.errorText, error), (0, _defineProperty2["default"])(_cx, classes.disabledText, isDisabled), _cx))
        }
      }, labelProps), label), /*#__PURE__*/_react["default"].createElement("div", {
        className: helperText ? classes.menuAnchorWithHelperText : classes.menuAnchor
      }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
        automationid: "".concat(automationid, "-input"),
        className: classes.input,
        dataMetrics: {
          root: mergedDataMetrics.input
        },
        disabled: Boolean(isDisabled),
        error: error,
        fullWidth: true,
        InputProps: _objectSpread({}, InputProps, {
          endAdornment: showDropdownIndicator && DropdownIndicator
        }),
        inputRef: this.inputRef,
        onClick: this.onMenuClick,
        onKeyDown: handleKey,
        readOnly: true,
        ref: this.popperAnchorRef,
        value: inputDisplayValue
      }, inputPropsRest)), helperText && /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
        automationid: "".concat(automationid, "-helpertext"),
        classes: {
          root: (0, _classnames["default"])(classes.label, (0, _defineProperty2["default"])({}, classes.errorText, error))
        },
        color: "textSecondary",
        dataMetrics: {
          root: mergedDataMetrics.helperText
        },
        display: "inline",
        variant: "caption"
      }, helperTextProps), helperText), Boolean(isDisabled) === false && withMenuIsOpen && Menu)));
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-metrics": mergedDataMetrics.root
      }, withMenu ? WithMenu : ActualSelect);
    }
  }]);
  return SelectMulti;
}(_react["default"].Component);
exports.SelectMulti = SelectMulti;
SelectMulti.defaultProps = defaultProps;
SelectMulti.displayName = 'SelectMultiClass';
SelectMulti.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Props to pass to the buttons in the footer section.
   *
   * > `id: string | number`
   * > `label: string` - **required** <br>
   * > `onClick: func` - **required** <br>
   * > `disabled: boolean`,
   * > `size: small | medium `
   */
  actionFooterProps: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    onClick: _propTypes["default"].func.isRequired
  })),
  /**
   * Allow passing customized action component.
   *
   * @param {func} closeMenu Callback to collapse the menu.
   */
  actionProps: _propTypes["default"].func,
  /** Time (in ms) to wait before firing async call.  */
  asyncDebounceTime: _propTypes["default"].number,
  /**
   * Prefix for automationid used for automated testing selectors.
   * @ignore
   */
  automationid: _propTypes["default"].string,
  /**
   * When isAsync is true, the minimum number of characters typed before
   * fetching results.
   */
  charsBeforeFetch: _propTypes["default"].number,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    helperText: _propTypes["default"].string,
    input: _propTypes["default"].string,
    label: _propTypes["default"].string,
    loadingMessage: _propTypes["default"].string,
    menuContainer: _propTypes["default"].string,
    noResultsOption: _propTypes["default"].string,
    optionList: _propTypes["default"].string,
    outerMenu: _propTypes["default"].string,
    root: _propTypes["default"].string,
    searchInput: _propTypes["default"].string,
    searchInputWrapper: _propTypes["default"].string,
    selectWrapper: _propTypes["default"].string,
    viewSelected: _propTypes["default"].string
  }),
  /** If true, component will be in error state. */
  error: _propTypes["default"].bool,
  /**  Text displayed as helpertext. */
  helperText: _propTypes["default"].string,
  /** Props for the helperText's typography component. */
  helperTextProps: _propTypes["default"].object,
  /**
   * Additional props to apply to the inputElement used for searching.
   */
  inputProps: _propTypes["default"].object,
  /** Ref for the input component displaying values in the withMenu variant. */
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].any
  })]),
  /** Ref for the wrapper of the withMenu variant */
  inputWrapperRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].any
  })]),
  /**
   * If true, component will fetch options asynchronously using provided
   * loadOptions prop.
   */
  isAsync: _propTypes["default"].bool,
  /**
   * If `true`, the select will be disabled.
   * To disable a group, all child selection(s) should be disabled manually.
   */
  isDisabled: _propTypes["default"].bool,
  /**
   * If `true`, options will be sorted alpha-numerically.
   */
  isSorted: _propTypes["default"].bool,
  /** Text for the label */
  label: _propTypes["default"].string,
  /**
   * Props for the label's typography component.
   */
  labelProps: _propTypes["default"].object,
  /** Text to display when loading. */
  loadingMessage: _propTypes["default"].string,
  /** Function called when isAsync is true on typeahead, should return a promise that resolves with an array of options. */
  loadOptions: _propTypes["default"].func,
  /** Maximum height of the dropdown list. */
  maxDropdownHeight: _propTypes["default"].number,
  /** Ref for the dropdown menu. */
  menuContainerRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].any
  })]),
  /** Width of the menu when dropdown list is expanded. */
  menuWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  noResultsText: _propTypes["default"].string,
  /** Fired with new value upon selectAll / toggleViewSelected / optionChange. */
  onChange: _propTypes["default"].func.isRequired,
  /** Fired when clicking outside of the search input of the standalone variant. */
  onInputBlur: _propTypes["default"].func,
  options: _propTypes["default"].array,
  /** Placeholder text for withMenu variant. */
  placeholder: _propTypes["default"].string,
  /**
   * Props applied to the Paper element. Note: Popper is only used when portalMenu={true}
   */
  PopperProps: _propTypes["default"].object,
  /**
   * Determines whether menu will be rendered in portal using Popper component. When using SelectMulti inside Modal or
   * Side Panel components, set portalMenu to false to avoid rendering issues.
   * Note: Only applies when `withMenu` variant is selected.
   */
  portalMenu: _propTypes["default"].bool,
  /** Override props applied to the SearchInput component. */
  searchInputProps: _propTypes["default"].object,
  /** Ref for the search input. */
  searchInputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].any
  })]),
  /** Placeholder text of the search box in all variants. */
  searchPlaceholder: _propTypes["default"].string,
  /** Text describing the viewSelected switch. */
  selectSwitchLabelText: _propTypes["default"].string,
  /** Whether or not to show the count of selected options. */
  showCountOfSelectedOptions: _propTypes["default"].bool,
  /** Whether or not to show the dropdown indicator. */
  showDropdownIndicator: _propTypes["default"].bool,
  /** Configuration for which option list controls to show, if any. */
  showOptionListHeader: _propTypes["default"].oneOf(['all', 'select-all', 'view-selected', 'none']),
  /**
   * @ignore
   */
  theme: _propTypes["default"].object,
  /*
   * The value of the component.
   */
  value: _propTypes["default"].array.isRequired,
  variant: _propTypes["default"].oneOf(['withMenu', 'standalone']),
  /** Ref for the wrapper of the standalone variant (also used within withMenu variant). */
  wrapperRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].any
  })])
} : {};
var ExportComponent = (0, _styles.withStyles)(styles)((0, _styles.withTheme)(SelectMulti));
ExportComponent.displayName = 'SelectMulti';
var _default = ExportComponent;
exports["default"] = _default;